import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MembershipTypes } from '@guryou/core';

// include type subscription for specific provider only
// available only for Studio fitness and Passion Iron
// const getOptions = (t, providerId) => {
//   if (providerId && [260, 976, 1478, 1373, 289, 756].includes(+providerId)) {
//     return [
//       { label: t('GENERAL.service'), value: MembershipTypes.service },
//       { label: t('GENERAL.course/event'), value: MembershipTypes.courseOrEvent },
//       { label: t('GENERAL.subscription'), value: MembershipTypes.subscription },
//     ];
//   }
//   return [
//     { label: t('GENERAL.service'), value: MembershipTypes.service },
//     { label: t('GENERAL.course/event'), value: MembershipTypes.courseOrEvent },
//     // { label: t('GENERAL.video'), value: MembershipTypes.video },
//     // { label: t('GENERAL.workout'), value: MembershipTypes.workout },
//   ];
// };

const useMembershipTypes = function () {
  let includeSubscriptionType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const [values, setValues] = useState(null);
  const {
    t
  } = useTranslation();

  // const providerDetails = useSelector(state => state.provider.generalInfo);
  // const options = getOptions(t, providerDetails?.data?.id);

  const options = [{
    label: t('GENERAL.service'),
    value: MembershipTypes.service
  }, {
    label: t('GENERAL.course/event'),
    value: MembershipTypes.courseOrEvent
  }];
  if (includeSubscriptionType) {
    options.push({
      label: t('GENERAL.subscription'),
      value: MembershipTypes.subscription
    });
  }
  if (!values) {
    setValues(options);
  }
  return values;
};
export { useMembershipTypes };